<template>
  <div>
    <v-layout class="mt-5" v-if="isLoading" align-center justify-center column fill-height>
      <v-progress-circular size="70" width="7" color="purple" indeterminate="indeterminate">
      </v-progress-circular>
      <div>Loading...</div>
    </v-layout>
    <div v-if="!isLoading">
      <v-alert class="ma-0" transition="slide-y-reverse-transition" :value="location.alertOn" type="error">{{
        location.Notes
      }}</v-alert>
      <v-alert class="ma-0" transition="slide-y-reverse-transition" :value="location.testStore" dismissible
        type="warning">This is Test Location</v-alert>
      <v-alert class="ma-0" transition="slide-y-reverse-transition" :value="location.Organization.alertOn" type="warning">
        <v-layout column>
          <h2 class="headline font-weight-medium">Organization Note</h2>
          <p>{{ location.Organization.notes }}</p>
        </v-layout>
      </v-alert>
      <v-toolbar class="elevation-0" color="info" dark="dark">
        <v-toolbar-title>
          <v-icon class="mr-1" medium>mdi-store</v-icon>
          <span>{{ location.CSPID }} - {{ location.businessName }}</span>
        </v-toolbar-title>
        <v-spacer> </v-spacer>
        <TimeClock :timeZoneId="location.timeZoneId"> </TimeClock>
        <v-menu bottom="bottom" left="left" offset-y="offset-y">
          <v-btn slot="activator" icon="icon">
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile @click="editStore" v-if="checkRightStatus(13)">
              <v-list-tile-content>
                <v-list-tile-title>{{ $t("buttons.edit") }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="softwareUpdate" v-if="checkRightStatus(49)">
              <v-list-tile-content>
                <v-list-tile-title>{{
                  $t("buttons.update")
                }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile :disabled="!checkRightStatus(64)" @click="addLocation">
              <v-list-tile-content>
                <v-list-tile-title>{{
                  $t("buttons.addLocation")
                }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="serviceDialog = true">
              <v-list-tile-content>
                <v-list-tile-title>{{
                  $t("buttons.service")
                }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <div v-if="checkRightStatus(58)">
              <v-list-tile @click="createDatabase" v-if="!databaseInProgess">
                <v-list-tile-content>
                  <v-list-tile-title>{{
                    $t("buttons.createDatabase")
                  }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </div>
            <v-divider> </v-divider>
            <v-list-tile :disabled="!checkRightStatus(65)" @click="openActivity">
              <v-list-tile-content>
                <v-list-tile-title>{{
                  $t("buttons.activity")
                }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar>
      <v-card class="border-r-0">
        <v-card-title primary-title="primary-title">
          <v-layout row wrap>
            <v-flex xs12 sm9>
              <v-layout column>
                <div>
                  <span>Address: </span>
                  <span class="font-weight-medium">
                    <v-tooltip class="ml-1 pointer" bottom="bottom">
                      <template slot="activator">
                        <a @click="openGoogleMap">{{ location.address }} {{ location.city }},
                          <span v-if="location.State">{{ location.State.stateSymbol }}
                          </span>
                          <span>{{ location.zipCode }}</span>
                        </a>
                      </template>
                      <span>Click to open google map</span>
                    </v-tooltip>
                  </span>
                </div>
                <div>
                  <span>{{ $t("labels.phoneNumber") }}: </span>
                  <span class="font-weight-medium">{{
                    location.businessPhone | USPhoneNumber
                  }}</span>
                  <span class="font-weight-medium ml-1" v-if="location.cellPhone">| {{ location.cellPhone |
                    USPhoneNumber
                  }}</span>
                </div>
                <div>
                  <span>{{ $t("labels.primaryEmail") }}: </span>
                  <span class="font-weight-medium" v-if="organization.primaryEmail">
                    <a @click="sendEmail(organization.primaryEmail)">{{
                      organization.primaryEmail
                    }}</a>
                  </span>
                </div>
                <div>
                  <span>{{ $t("labels.createdAt") }}: </span>
                  <span class="font-weight-medium">{{ location.createDateTIme | moment("MM/DD/YYYY") }} |
                    {{ location.createDateTIme | moment("from", "now") }}</span>
                </div>
                <div class="mt-2" v-if="!service.csp4">
                  <v-chip v-if="feedbackCount !== 0" color="#ffd0d2" text-color="#ff3840">
                    <v-avatar>
                      <v-icon small="small">star_half</v-icon>
                    </v-avatar>
                    <span class="mr-1 font-weight-medium">{{
                      feedbackCount
                    }}</span>
                    <span>Pending Feedback</span>
                  </v-chip>


                  <v-dialog v-model="anyDeskDialog" width="500">
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip class="pointer" color="orange" v-bind="attrs" v-on="on">
                        <v-avatar>
                          <v-icon small="small">mdi-laptop</v-icon>
                        </v-avatar>
                        <span class="mr-1 font-weight-medium" v-if="anyDeskId"> {{ anyDeskId }}</span>
                        <span v-else class="mr-1 font-weight-medium">Set Code</span>
                      </v-chip>

                      <!-- <v-btn color="red lighten-2" dark v-bind="attrs" v-on="on">
                        Click Me
                      </v-btn> -->
                    </template>

                    <v-card>
                      <v-card-title class="text-h5 grey lighten-2">
                        AnyDesk ID
                      </v-card-title>

                      <v-card-text>
                        <v-layout row wrap>
                          <v-flex>
                            <v-text-field :disabled="!anydeskEdit" v-model="anyDeskId" label="AnyDesk ID">
                            </v-text-field>
                          </v-flex>
                          <v-flex shrink>
                            <v-btn @click="copyCode(anyDeskId)" color="success">Copy</v-btn>
                          </v-flex>
                          <v-flex shrink>
                            <v-btn color="primary" @click="anydeskEdit = !anydeskEdit">Edit</v-btn>
                          </v-flex>
                        </v-layout>
                      </v-card-text>

                      <v-divider></v-divider>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" flat @click="anyDeskId = location.anyDeskId; anyDeskDialog = false">
                          Close
                        </v-btn>
                        <v-btn color="primary" @click="updateAnyDesk">
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                  <v-chip class="pointer" v-if="location" :color="color" @click="$emit('active', 4)">
                    <v-avatar>
                      <v-icon small="small">account_balance_wallet</v-icon>
                    </v-avatar>
                    <span class="mr-1 font-weight-medium">{{ location.prepaidBalance | currency }}
                    </span>
                    <span>Wallet Balance</span>
                  </v-chip>
                </div>
              </v-layout>
            </v-flex>
            <v-flex hidden-xs-only="hidden-xs-only" sm3="sm3">
              <v-layout column>
                <div class="text-xs-right" v-if="location.isLocked">
                  <v-icon large="large" color="red">lock</v-icon>
                </div>
                <div class="text-xs-right" v-else="v-else">
                  <v-icon large="large" color="green">lock_open</v-icon>
                </div>
                <div class="text-xs-right" v-if="location.isCanceled">
                  <v-icon large="large" color="red">desktop_access_disabled
                  </v-icon>
                </div>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-title>
      </v-card>
      <Activity :activityDialog="activityDialog" @close="closeActivity" :refID="location.storeID" typeId="1">
      </Activity>
      <Edit :editDialog="editDialog" @close="close" @updated="updated"> </Edit>
      <Service :serviceDialog="serviceDialog" @saved="serviceSaved" @close="serviceDialog = false">
      </Service>
      <v-tabs v-model="active" color="blue-grey lighten-5" slider-color="info">
        <v-tab class="text-transform-none">{{ $t("labels.dashboard") }}</v-tab>
        <v-tab v-if="checkRightStatus(3)" class="text-transform-none">{{ $t("labels.billing") }}</v-tab>
        <v-tab v-if="checkRightStatus(42)" class="text-transform-none">{{ $t("labels.tickets") }}</v-tab>
        <v-tab class="text-transform-none">{{ $t("labels.promotion") }}</v-tab>

        <v-tab class="text-transform-none" v-if="service.reconcile">{{
          $t("labels.reconcile")
        }}</v-tab>
        <v-tab class="text-transform-none" v-if="service.commercial">{{
          $t("labels.commercial")
        }}</v-tab>
        <v-tab class="text-transform-none">{{ $t("labels.feedback") }}</v-tab>
        <v-tab class="text-transform-none" v-if="checkRightStatus(63)">{{
          $t("labels.wallet")
        }}</v-tab>
        <v-tab class="text-transform-none">{{
          $t("labels.otherLocation")
        }}</v-tab>
        <v-tab class="text-transform-none" v-if="service.csp4">CSP4</v-tab>
        <v-tabs-items touchless="touchless">
          <v-tab-item>
            <Dashboard @active="changeActive"> </Dashboard>
          </v-tab-item>
          <v-tab-item v-if="checkRightStatus(3)" lazy>
            <Billing> </Billing>
          </v-tab-item>
          <v-tab-item v-if="checkRightStatus(42)" lazy>
            <Ticket> </Ticket>
          </v-tab-item>
          <v-tab-item lazy>
            <Promotion :location="location"> </Promotion>
          </v-tab-item>
          <v-tab-item lazy v-if="service.reconcile">
            <Reconcile> </Reconcile>
          </v-tab-item>
          <v-tab-item lazy v-if="service.commercial">
            <Commercial> </Commercial>
          </v-tab-item>

          <v-tab-item lazy>
            <Feedback :location="location"> </Feedback>
          </v-tab-item>
          <v-tab-item v-if="checkRightStatus(63)" lazy>
            <Wallet> </Wallet>
          </v-tab-item>
          <v-tab-item lazy>
            <v-container fluid="grid-list-lg">
              <OtherStoreList :location="organization.Stores" :title="$t('pageHeader.otherLocation')">
              </OtherStoreList>
            </v-container>
          </v-tab-item>
          <v-tab-item lazy v-if="service.csp4">
            <Csp4Board> </Csp4Board>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import locationService from '../service.js';
import TimeClock from '../../Global/components/TimeClock';
import Dashboard from '../components/Dashboard';
import Csp4Board from '../components/Csp4Board';
import Commercial from '../components/Commercial';
import Reconcile from '../components/Reconcile';
import Service from '../components/Service';

const Feedback = () => import('../components/Feedback');
const Promotion = () => import('@/modules/Promotion/components/List.vue');
const Edit = () => import('../components/Edit');
const Wallet = () => import('../components/Wallet');
const Billing = () => import('../components/Billing');
const Ticket = () => import('../components/Ticket/Ticket');
const OtherStoreList = () => import('../components/OtherStoreList');
const Activity = () => import('../../Comment/components/ActivityDialog');

export default {
  name: 'location-view-profile',
  data() {
    return {
      anydeskEdit: false,
      anyDeskId: null,
      anyDeskDialog: false,
      cspv4Service: false,
      databaseInProgess: false,
      serviceDialog: false,
      currentTime: '8:36:36 PM',
      createDatabaseDialog: false,
      editDialog: false,
      feedbackCount: 0,
      active: null,
      activityDialog: false,
      cancelDialog: false,
      Reports: {
        Sales: null,
      },
      subscription: null,
      isLoading: true,
    };
  },
  watch: {
    $route(to, from) {
      if (to && from && to.name === from.name) {
        this.loadEverything();
        this.getFeedbackCount();
      }
    },
  },
  computed: {
    ...mapGetters('location', ['location', 'organization', 'service']),
    ...mapGetters('global', ['checkRightStatus', 'comboBoxByID']),
    color() {
      if (this.location.prepaidBalance > 4) {
        return '#d2f8d2';
      }
      return '#ffd0d2';
    },
    checkV4Service() {
      this.location.ProductRelations.forEach((val) => {
        if (val.serviceID == '198') {
          this.cspv4Service = true;
        }
      });
    },
  },
  components: {
    Activity,
    Service,
    Dashboard,
    TimeClock,
    Commercial,
    Ticket,
    Reconcile,
    Edit,
    Wallet,
    Feedback,
    Billing,
    OtherStoreList,
    Csp4Board,
    Promotion,
  },
  async created() {
    await this.loadEverything();
    await this.getFeedbackCount();
    if (this.$route.query) {
      if (this.$route.query.type === '5') this.active = 3;
    }
  },
  methods: {
    ...mapActions('location', ['setLocation', 'setOrganization']),
    updateAnyDesk() {
      const editData = {
        anyDeskId: this.anyDeskId,
      }
      console.log('anyDeskId', editData)
      this.anyDeskDialog = !this.anyDeskDialog
      this.anydeskEdit = false
      return locationService.updateStore(this.location.storeID, editData)

    },
    openAnyDeskId() {
      this.anyDeskDialog = !this.anyDeskDialog
    },
    copyCode(code) {
      navigator.clipboard.writeText(code);
      const Toast = this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
      });

      Toast.fire({
        type: 'success',
        title: 'Id Copy',
      });
      // this.$toast.success("Location code was copy", { timeout: 2000 });
    },
    serviceSaved() {
      this.serviceDialog = false;
      this.loadEverything();
    },
    createDatabase() {
      this.$swal({
        title: 'Are you sure?',
        text: `You want to create database for ${this.location.CSPID}`,
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'No',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          this.$Progress.start();
          return locationService
            .createDatabase(this.location.storeID)
            .then((response) => {
              console.log(response);
              this.$Progress.finish();
              this.setLocation(this.location.storeID);
              this.$swal(
                'Create Database',
                'Progress has start, you will be notify once database is created!',
                'success',
              );
              this.databaseInProgess = true;
            })
            .catch((error) => {
              // console.log('error, error', error)
              // this.$swal.mixin({
              //   toast: true,
              //   position: 'top-end',
              //   showConfirmButton: false,
              //   timer: 3000
              // }).fire({
              //   type: 'error',
              //   title: error.data.data
              // })

              this.$swal('Create Database', error.data.data, 'warning');

              this.$Progress.fail();
            });
        }
      });
    },
    editStore() {
      this.editDialog = true;
    },
    addLocation() {
      this.$router.push({
        path: `/location/${this.location.Organization.organizationID}/new`,
      });
    },
    openGoogleMap() {
      window.open(
        `https://www.google.com/maps/place/${this.location.address} ${this.location.city},${this.location.State.stateSymbol} ${this.location.zipCode}`,
        '_blank',
      );
    },
    softwareUpdate() {
      this.$swal({
        title: this.$t('messages.title.areYouSure'),
        html: `you want give update to <b>${this.location.businessName}</b> and all other locations.`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: this.$t('buttons.no'),
        confirmButtonText: this.$t('buttons.yes'),
      })
        .then((result) => {
          if (result.value) {
            locationService
              .giveSoftwareUpdate(this.location.Organization.organizationID)
              .then((response) => {
                this.setLocation(this.location.storeID);
                this.$swal('Update', response, 'success');
              });
          }
        })
        .catch((error) => {
          // todo present this to the user
          console.log(error);
        });
    },
    updated() {
      this.close();
    },
    getFeedbackCount() {
      return locationService
        .getFeedbackCount(this.location.storeID)
        .then((result) => {
          this.feedbackCount = result.data;
        });
    },
    async loadEverything() {
      await this.loadLocation();
      await this.loadOrganization(this.location.Organization.organizationID);
      this.isLoading = false;
    },
    changeActive(val) {
      this.active = val;
    },
    openActivity() {
      this.activityDialog = true;
    },
    close() {
      this.editDialog = false;
    },
    closeActivity() {
      this.activityDialog = false;
    },
    async loadLocation() {
      // console.log("this.$route.params", this.$route);
      if (!this.$route.params || !this.$route.params.id) {
        return this.$router.push('/location');
      }
      const { id } = this.$route.params;
      this.$Progress.start();

      // this.databaseInProgess = this.location.databaseInProgess;

      await this.setLocation(id);
      // console.log('anyDeskIdanyDeskIdanyDeskId', this.location)
      if (this.location && this.location.anyDeskId) {
        this.anyDeskId = this.location.anyDeskId
      } else {
        this.anyDeskId = null
      }
      this.$Progress.finish();
      return true
    },
    loadOrganization(id) {
      this.$Progress.start();
      return locationService.getAllStoreByOrg(id).then((response) => {
        this.$Progress.finish();
        this.setOrganization(response.data);
      });
      // .catch((error) => {
      //   this.$router.push('/location')
      // })
    },
  },
};
</script>
